import { width } from "./width"

export const getDeviceByWidth = () =>{
    const devices = ["phone","tablet","laptop"]

    for (const device of devices) {
        if(width(device))return device
      }
}